import { render } from "./OVPOAEModal.vue?vue&type=template&id=9ba1ce1c&ts=true"
import script from "./OVPOAEModal.vue?vue&type=script&lang=ts"
export * from "./OVPOAEModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__